import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetTable({baseId, apiKey, tableNameOrId}: { baseId?: string, apiKey?: string, tableNameOrId?: string }) {
    return useQuery({
        ...queryKeys.airtable.table(baseId!, apiKey!)._ctx.details(tableNameOrId!),
        enabled: !!apiKey && !!baseId && !!tableNameOrId,
    })
}